<template>
    <div>
        <template v-if="viewPage == true">
            <form @submit.prevent="addMerchant">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Merchant </h1>
                </div>
                <div class="company-main">
                    <div class="company-inner">
                        <div class="tab-content-inner">
                            <div class="form-group">
                                <label class="label block-label"> Name <em class="required">*</em> </label>
                                <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name')}" placeholder="Enter company name">
                                <has-error :form="form" field="name"></has-error>
                            </div>
                            <div class="form-group">
                                <label class="label block-label"> Email <em class="required">*</em> </label>
                                <input v-model="form.email" type="text" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email')}" placeholder="Enter company email">
                                <has-error :form="form" field="email"></has-error>
                            </div>
                            <div class="form-group">
                                <label class="label block-label"> Phone <em class="required">*</em> </label>
                                <input v-model="form.phone" type="text" name="phone" class="form-control" :class="{ 'is-invalid': form.errors.has('phone')}" placeholder="Format 923052273575">
                                <has-error :form="form" field="phone"></has-error>
                            </div>
                            <div class="form-group">
                                <label class="label block-label"> Wallet ID <em class="required">*</em> </label>
                                <input v-model="form.wallet_id" type="text" name="wallet_id" class="form-control" :class="{ 'is-invalid': form.errors.has('wallet_id')}" placeholder="Enter Merchant Wallet ID">
                                <has-error :form="form" field="wallet_id"></has-error>
                            </div>
                             <div class="form-group">
                                <label class="label block-label"> Address <em class="required">*</em> </label>
                                <textarea class="form-control" rows="3" name="address1" v-model="form.address1" :class="{ 'is-invalid': form.errors.has('address1')}"></textarea>
                             <has-error :form="form" field="address1"></has-error>
                            </div>
                            <div class="form-group">
                                <label> City <em class="required">*</em></label>
                                <select v-model="form.city_id" name="city_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('city_id') }">
                                    <option v-for="city in cities" :key="city.id" :value="city.id">{{city.name}}</option>
                                </select>
                                <has-error :form="form" field="city_id"></has-error>
                            </div>
                            <div class="form-group">
                                <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                <router-link to="/generateMerchantPayment" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="viewPage === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="viewPage === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
             return {
                viewPage: null,
                form: new Form({
                    name: null,
                    email: null,
                    phone: null,
                    wallet_id: null,
                    address1: null,
                    city_id: null
                }),
                cities: []
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('add_merchant_payment').then(result => {
                this.viewPage = result.add_merchant_payment;
                this.$Progress.finish();
            }).then(result => {
                this.getCities();
            });
        },
        methods: {
            getCities(){
                 axios.get('/api/cityData')
                .then(res => {
                    if(res.status == 200){
                        this.cities = res.data.record;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res =>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },

            addMerchant(){
                this.$Progress.start();
                this.form.post('api/addMerchantData')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Merchant added successfully');
                        this.$router.push('/generateMerchantPayment');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }

                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            }
        },
    }
</script>